import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../img/logo.png";

const TopMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [openSubmenu, setOpenSubmenu] = useState(null); // tracks open submenu
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    // handle resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };
        window.addEventListener("resize", handleResize);
        handleResize(); // init
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // open/close submenu only on mobile
    const toggleSubmenu = (menuKey) => {
        if (isMobile) {
            setOpenSubmenu(openSubmenu === menuKey ? null : menuKey);
        }
    };

    // navigation handler
    const navHandler = (e, callback) => {
        if (e.ctrlKey || e.metaKey || e.button === 1) return; // allow new tab
        e.preventDefault();
        callback();
        if (isMobile) setOpenSubmenu(null); // close submenu after click
    };

    const isActive = (path) => (location.pathname === path ? "active" : "");

    return (
        <>
            {/* Main Menu */}
            <nav
                className={`mainmenu-nav ${isMobile ? "offcanvas" : ""}`}
                id="mobilemenu-popup"
            >
                {/* Mobile Header */}
                <div className="d-block d-lg-none">
                    <div className="mobile-nav-header">
                        <div className="mobile-nav-logo">
                            <a href="/">
                                <img className="light-mode" src={logo} alt="Site Logo" />
                                <img className="dark-mode" src={logo} alt="Site Logo" />
                            </a>
                        </div>
                        <button
                            className="mobile-menu-close"
                            data-bs-dismiss="offcanvas"
                            onClick={() => setOpenSubmenu(null)}
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <ul className="mainmenu">
                    {/* Home */}
                    <li className="menu-item-open cursor-pointer">
                        <a
                            href="/"
                            className={isActive("/")}
                            onClick={(e) => navHandler(e, () => navigate("/"))}
                        >
                            Home
                        </a>
                    </li>

                    {/* Convertor */}
                    <li
                        className={`menu-item-has-children ${openSubmenu === "convertor" ? "open" : ""
                            }`}
                    >
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleSubmenu("convertor");
                            }}
                        >
                            Convertor
                        </a>
                        <ul
                            className="main-submenu"
                            style={
                                isMobile
                                    ? { display: openSubmenu === "convertor" ? "block" : "none" }
                                    : {}
                            }
                        >
                            <li>
                                <a
                                    href="/json-to-xml-convertor"
                                    className={isActive("/json-to-xml-convertor")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/json-to-xml-convertor"))
                                    }
                                >
                                    JSON to XML
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/xml-to-json-convertor"
                                    className={isActive("/xml-to-json-convertor")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/xml-to-json-convertor"))
                                    }
                                >
                                    XML to JSON
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/json-to-string-convertor"
                                    className={isActive("/json-to-string-convertor")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/json-to-string-convertor"))
                                    }
                                >
                                    JSON to STRING
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/string-to-json-convertor"
                                    className={isActive("/string-to-json-convertor")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/string-to-json-convertor"))
                                    }
                                >
                                    STRING TO JSON
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/json-to-html-convertor"
                                    className={isActive("/json-to-html-convertor")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/json-to-html-convertor"))
                                    }
                                >
                                    JSON TO HTML
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/text-to-binary-convertor"
                                    className={isActive("/text-to-binary-convertor")}
                                    onClick={(e) => navHandler(e, () => navigate("/text-to-binary-convertor"))}
                                >
                                    Text to Binary
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/binary-to-text-convertor"
                                    className={isActive("/binary-to-text-convertor")}
                                    onClick={(e) => navHandler(e, () => navigate("/binary-to-text-convertor"))}
                                >
                                    Binary to Text
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/currency-convertor"
                                    className={isActive("/currency-convertor")}
                                    onClick={(e) => navHandler(e, () => navigate("/currency-convertor"))}
                                >
                                    Currency Convertor
                                </a>
                            </li>

                        </ul>
                    </li>

                    {/* Minifier */}
                    <li
                        className={`menu-item-has-children ${openSubmenu === "minifier" ? "open" : ""
                            }`}
                    >
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleSubmenu("minifier");
                            }}
                        >
                            Minifier
                        </a>
                        <ul
                            className="main-submenu"
                            style={
                                isMobile
                                    ? { display: openSubmenu === "minifier" ? "block" : "none" }
                                    : {}
                            }
                        >
                            <li>
                                <a
                                    href="/json-minifier"
                                    className={isActive("/json-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/json-minifier"))}
                                >
                                    JSON Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/xml-minifier"
                                    className={isActive("/xml-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/xml-minifier"))}
                                >
                                    XML Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/html-minifier"
                                    className={isActive("/html-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/html-minifier"))}
                                >
                                    HTML Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/css-minifier"
                                    className={isActive("/css-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/css-minifier"))}
                                >
                                    CSS Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/javascript-minifier"
                                    className={isActive("/javascript-minifier")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/javascript-minifier"))
                                    }
                                >
                                    JavaScript Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/typescript-minifier"
                                    className={isActive("/typescript-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/typescript-minifier"))}
                                >
                                    TypeScript Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/sql-minifier"
                                    className={isActive("/sql-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/sql-minifier"))}
                                >
                                    SQL Minifier
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/yaml-minifier"
                                    className={isActive("/yaml-minifier")}
                                    onClick={(e) => navHandler(e, () => navigate("/yaml-minifier"))}
                                >
                                    YAML Minifier
                                </a>
                            </li>

                        </ul>
                    </li>

                    {/* Formatter */}
                    <li
                        className={`menu-item-has-children ${openSubmenu === "formatter" ? "open" : ""
                            }`}
                    >
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleSubmenu("formatter");
                            }}
                        >
                            Formatter
                        </a>
                        <ul
                            className="main-submenu"
                            style={
                                isMobile
                                    ? { display: openSubmenu === "formatter" ? "block" : "none" }
                                    : {}
                            }
                        >
                            <li>
                                <a
                                    href="/css-formatter"
                                    className={isActive("/css-formatter")}
                                    onClick={(e) => navHandler(e, () => navigate("/css-formatter"))}
                                >
                                    CSS Formatter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/xml-formatter"
                                    className={isActive("/xml-formatter")}
                                    onClick={(e) => navHandler(e, () => navigate("/xml-formatter"))}
                                >
                                    XML Formatter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/html-formatter"
                                    className={isActive("/html-formatter")}
                                    onClick={(e) => navHandler(e, () => navigate("/html-formatter"))}
                                >
                                    HTML Formatter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/sql-formatter"
                                    className={isActive("/sql-formatter")}
                                    onClick={(e) => navHandler(e, () => navigate("/sql-formatter"))}
                                >
                                    SQL Formatter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/html-color-codes"
                                    className={isActive("/html-color-codes")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/html-color-codes"))
                                    }
                                >
                                    HTML Color Codes
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/python-formatter"
                                    className={isActive("/python-formatter")}
                                    onClick={(e) => navHandler(e, () => navigate("/python-formatter"))}
                                >
                                    Python Formatter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/regex-tester"
                                    className={isActive("/regex-tester")}
                                    onClick={(e) => navHandler(e, () => navigate("/regex-tester"))}
                                >
                                    Regex Tester & Formatter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/typescript-formatter"
                                    className={isActive("/typescript-formatter")}
                                    onClick={(e) => navHandler(e, () => navigate("/typescript-formatter"))}
                                >
                                    TypeScript Formatter
                                </a>
                            </li>

                        </ul>
                    </li>

                    {/* Base64 Tools */}
                    <li
                        className={`menu-item-has-children ${openSubmenu === "base64" ? "open" : ""
                            }`}
                    >
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleSubmenu("base64");
                            }}
                        >
                            Base64 Tools
                        </a>
                        <ul
                            className="main-submenu"
                            style={
                                isMobile
                                    ? { display: openSubmenu === "base64" ? "block" : "none" }
                                    : {}
                            }
                        >
                            <li>
                                <a
                                    href="/base64-to-image-conversion"
                                    className={isActive("/base64-to-image-conversion")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/base64-to-image-conversion"))
                                    }
                                >
                                    Base64 To Image
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/image-to-base64-conversion"
                                    className={isActive("/image-to-base64-conversion")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/image-to-base64-conversion"))
                                    }
                                >
                                    Image To Base64
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/base64-to-ascii-conversion"
                                    className={isActive("/base64-to-ascii-conversion")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/base64-to-ascii-conversion"))
                                    }
                                >
                                    Base64 To ASCII
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/ascii-to-base64-conversion"
                                    className={isActive("/ascii-to-base64-conversion")}
                                    onClick={(e) =>
                                        navHandler(e, () => navigate("/ascii-to-base64-conversion"))
                                    }
                                >
                                    ASCII To Base64
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/jwt-decode"
                                    className={isActive("/jwt-decode")}
                                    onClick={(e) => navHandler(e, () => navigate("/jwt-decode"))}
                                >
                                    JWT Decode
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/uuid-generator"
                                    className={isActive("/uuid-generator")}
                                    onClick={(e) => navHandler(e, () => navigate("/uuid-generator"))}
                                >
                                    UUID Generator
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/lorem-ipsum"
                                    className={isActive("/lorem-ipsum")}
                                    onClick={(e) => navHandler(e, () => navigate("/lorem-ipsum"))}
                                >
                                    Lorem Ipsum Generator
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/qrcode-generator"
                                    className={isActive("/qrcode-generator")}
                                    onClick={(e) => navHandler(e, () => navigate("/qrcode-generator"))}
                                >
                                    QR Code Generator
                                </a>
                            </li>

                        </ul>
                    </li>
                    {/* Interview */}
                     {/* <li className="menu-item-open cursor-pointer">
                        <a
                            href="/interviewlist"
                            className={isActive("/interview-questions")}
                            onClick={(e) => navHandler(e, () => navigate("/interviewlist"))}
                        >
                            Interviews
                        </a>
                    </li>  */}
                    {/* Blog */}
                    <li className="menu-item-open cursor-pointer">
                        <a
                            href="/blog"
                            className={isActive("/blog")}
                            onClick={(e) => navHandler(e, () => navigate("/blog"))}
                        >
                            Blog
                        </a>
                    </li>
                    {/* About */}
                    <li className="menu-item-open cursor-pointer">
                        <a
                            href="/about"
                            className={isActive("/about")}
                            onClick={(e) => navHandler(e, () => navigate("/about"))}
                        >
                            About
                        </a>
                    </li>
                    {/* Privacy */}
                    <li className="menu-item-open cursor-pointer">
                        <a
                            href="/privacy"
                            className={isActive("/privacy")}
                            onClick={(e) => navHandler(e, () => navigate("/privacy"))}
                        >
                            Privacy
                        </a>
                    </li>
                </ul>
            </nav>

            {/* Mobile Menu Button */}
            <div className="header-action">
                <ul className="list-unstyled">
                    <li className="mobile-menu-btn sidemenu-btn d-lg-none d-block">
                        <button
                            className="btn-wrap btn-dark"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#mobilemenu-popup"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default TopMenu;
